import { render } from "./np-router-toptabs.vue?vue&type=template&id=2b1d3d45&scoped=true"
import script from "./np-router-toptabs.vue?vue&type=script&lang=js"
export * from "./np-router-toptabs.vue?vue&type=script&lang=js"

import "./np-router-toptabs.vue?vue&type=style&index=0&id=2b1d3d45&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1d3d45"]])

export default __exports__